<div class="global-search" (focusout)="onFocusOut($event)">
  <i class="fa-solid fa-magnifying-glass search-icon" aria-hidden="true"></i>
  <input
    #input
    type="text"
    class="global-search-input"
    role="combobox"
    autocomplete="off"
    aria-autocomplete="list"
    [attr.aria-expanded]="open && groups.length > 0"
    [attr.aria-controls]="id + '-listbox'"
    [attr.aria-activedescendant]="
      activeIndex >= 0 ? id + '-option-' + activeIndex : null
    "
    [attr.aria-label]="'globalSearch.label.aria' | translate"
    [placeholder]="'globalSearch.label.placeholder' | translate"
    [value]="text"
    (input)="onInput(input.value)"
    (focus)="onFocus()"
    (keydown)="onKeydown($event)"
  />
  @if (loading) {
    <i class="fa-solid fa-spinner fa-spin search-loader" aria-hidden="true"></i>
  } @else {
    <kbd class="search-shortcut" aria-hidden="true">/</kbd>
  }
  @if (open && groups.length) {
    <div
      class="global-search-panel"
      role="listbox"
      [id]="id + '-listbox'"
      [attr.aria-label]="'globalSearch.label.aria' | translate"
    >
      @for (group of groups; track group.key) {
        @if (group.label) {
          <div class="search-group-label" role="presentation">
            {{ group.label | translate }}
          </div>
        }
        @for (option of group.options; track $index) {
          @let index = indexOf(option);
          <!-- The input keeps the focus: the options are picked by mouse or the arrow keys. -->
          <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
          <div
            class="search-option"
            role="option"
            tabindex="-1"
            [id]="id + '-option-' + index"
            [class.search-option-active]="index === activeIndex"
            [class.search-option-all]="option.kind === 'all'"
            [attr.aria-selected]="index === activeIndex"
            (mousedown)="$event.preventDefault()"
            (mouseenter)="activeIndex = index"
            (click)="select(option)"
          >
            @switch (option.kind) {
              @case ('company') {
                <i
                  class="fa-regular fa-building option-icon"
                  aria-hidden="true"
                ></i>
                <span class="option-text">
                  <span class="option-title">{{ option.company.name }}</span>
                  <span class="option-meta">{{ meta(option.company) }}</span>
                </span>
              }
              @case ('list') {
                <app-list-type-icon
                  class="option-icon"
                  [type]="option.list.type"
                  [large]="false"
                ></app-list-type-icon>
                <span class="option-text">
                  <span class="option-title">{{ option.list.name }}</span>
                </span>
              }
              @case ('recent') {
                <i
                  class="fa-solid fa-clock-rotate-left option-icon"
                  aria-hidden="true"
                ></i>
                <span class="option-text">
                  <span class="option-title">{{ option.search.label }}</span>
                </span>
              }
              @case ('all') {
                <i
                  class="fa-solid fa-arrow-right option-icon"
                  aria-hidden="true"
                ></i>
                <span class="option-text">
                  <span class="option-title">{{
                    'globalSearch.action.showAll'
                      | translate: { text: option.text }
                  }}</span>
                </span>
              }
            }
          </div>
        }
      }
    </div>
  }
</div>
